import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Alert } from 'xm-spark';
import XMLink from 'components/XMLink';
import { useRedirectAutomaticallyToAllEvents } from 'hooks/useRedirectAutomaticallyToAllEvents';
import HelpLink from 'Application/HelpLinks/HelpLink';
import styles from './EventRedirectAlert.module.scss';

const EventRedirectAlert = ({ eventId, eventType, redirectLink }) => {
  const setRedirectAutomaticallyToAllEvents =
    useRedirectAutomaticallyToAllEvents();

  return (
    <div
      className={`${styles.redesignedEventReport} ${
        eventType === 'RECENT' ? styles.recentEventsAlert : ''
      }`}
    >
      <Alert className={styles.alert}>
        <div>
          <FormattedMessage
            id={`RECENT_EVENTS_REDIRECT_${eventType}_EVENTS_BANNER`}
          />
          <HelpLink helpKey="EventReport">
            <FormattedMessage id="RECENT_EVENTS_REDIRECT_LEARN_MORE" />
          </HelpLink>
        </div>
        {eventId && (
          <XMLink
            to={redirectLink}
            onClick={() =>
              setRedirectAutomaticallyToAllEvents(eventType === 'RECENT')
            }
          >
            <FormattedMessage
              id={`RECENT_EVENTS_REDIRECT_${eventType}_EVENTS_BANNER_LINK`}
            />
          </XMLink>
        )}
      </Alert>
    </div>
  );
};

EventRedirectAlert.displayName = 'EventRedirectAlert';

EventRedirectAlert.propTypes = {
  eventId: PropTypes.string,
  eventType: PropTypes.string.isRequired,
  redirectLink: PropTypes.string.isRequired,
};

EventRedirectAlert.defaultProps = {
  eventId: null,
};

export default EventRedirectAlert;
